import { arrayOf, func, objectOf } from 'prop-types';
import React from 'react';

import { attachmentShape } from '../../prop-types';
import AttachmentGroup from '../AttachmentGroup';

function SmartCategorizedAttachmentsLayout({
  attachments,
  onDeleteFileSuccess,
}) {
  const entries = Object.entries(attachments);

  const colCountPerSection = 6 / Math.min(entries.length, 3);
  const colCount = Math.min(3, entries.length);

  return (
    <div className={`d-grid grid-col-${colCount}`}>
      {entries.map(([type, files]) => {
        return (
          <AttachmentGroup
            key={type}
            type={type}
            files={files}
            onDeleteFileSuccess={onDeleteFileSuccess}
            colCount={colCountPerSection}
          />
        );
      })}
    </div>
  );
}

SmartCategorizedAttachmentsLayout.propTypes = {
  attachments: objectOf(arrayOf(attachmentShape.isRequired).isRequired)
    .isRequired,
  onDeleteFileSuccess: func.isRequired,
};

export default SmartCategorizedAttachmentsLayout;
